import { useState } from 'react';
import { useReduxState } from 'hooks';
import { filterValuesSeparator } from 'shared-helpers/consts';
import { PathsViewAllPaths } from 'components/paths';

import type { HomeModuleProps } from './Home';

const HomePathsSelected = ({
  defaultTitle,
  module,
  spacing
}: HomeModuleProps) => {
  const { language } = useReduxState();

  const [noData, setNoData] = useState(false);

  if (!module || !module.paths?.length) return null;

  const queryParams = `&id=${module.paths.join(
    filterValuesSeparator
  )}&sortBy=queryIds`;

  const description =
    module.descriptionTranslations?.[language] || module.description;

  const title =
    module.titleTranslations?.[language] || module.title || defaultTitle;

  return (
    <div {...(!noData ? { style: { marginTop: spacing } } : {})}>
      <PathsViewAllPaths
        description={description}
        hideIfNoData={true}
        isHomeView={true}
        limitPerPage={module.limit}
        onNoData={(hasNoData) => setNoData(!hasNoData)}
        queryParams={queryParams}
        title={title}
        titleShowCount={false}
      />
    </div>
  );
};

export default HomePathsSelected;
